






import Vue from 'vue';
import Component from 'vue-class-component';
import { DeviceSessionConfig } from '@/models/data/models';

@Component({})
export default class DeviceSessionConfigList extends Vue {
  DeviceSessionConfig = DeviceSessionConfig;
  get filter() {
    return {
      application: this.$store.getters['global/application']
        ? this.$store.getters['global/application'].id
        : 'unknown', // explicitly set to 'unknown' to not show anything
    };
  }
}
